import { Link, useParams } from 'react-router-dom';
import { Markdown } from '../components/Markdown';
import { sdkBySlug, sdkEntries } from '../sdk/manifest';
import { useMemo } from 'react';

export function SdkPage() {
  const { slug = 'guide-overview' } = useParams();
  const entry = sdkBySlug.get(slug);

  const grouped = useMemo(() => {
    const out = new Map<string, typeof sdkEntries>();
    for (const e of sdkEntries) {
      if (!out.has(e.group)) out.set(e.group, []);
      out.get(e.group)!.push(e);
    }
    return out;
  }, []);

  if (!entry) {
    return (
      <div className="guide-shell">
        <div className="guide-content">
          <h1>Page not found</h1>
          <p>That SDK chapter doesn’t exist (yet). <Link to="/sdk/guide-overview">Back to the Developer Guide overview →</Link></p>
        </div>
      </div>
    );
  }

  const idx = sdkEntries.findIndex((e) => e.slug === entry.slug);
  const prev = idx > 0 ? sdkEntries[idx - 1] : null;
  const next = idx < sdkEntries.length - 1 ? sdkEntries[idx + 1] : null;

  return (
    <div className="guide-shell">
      <aside className="guide-sidebar">
        <div className="guide-sidebar__inner">
          {[...grouped.entries()].map(([group, items]) => (
            <section key={group}>
              <h3>{group}</h3>
              <ul>
                {items.map((item) => (
                  <li key={item.slug}>
                    <Link
                      to={`/sdk/${item.slug}`}
                      className={item.slug === entry.slug ? 'is-active' : undefined}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </aside>
      <article className="guide-content">
        <Markdown source={entry.body} />
        <nav className="guide-nav">
          {prev ? (
            <Link className="guide-nav__prev" to={`/sdk/${prev.slug}`}>
              <span>← Previous</span>
              <strong>{prev.title}</strong>
            </Link>
          ) : <span />}
          {next ? (
            <Link className="guide-nav__next" to={`/sdk/${next.slug}`}>
              <span>Next →</span>
              <strong>{next.title}</strong>
            </Link>
          ) : <span />}
        </nav>
      </article>
    </div>
  );
}
